import { computed, inject, Injectable, signal } from '@angular/core';
import { debounceTime, fromEvent, MonoTypeOperatorFunction, pipe, Subject, takeUntil, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ResolveStart, Router } from '@angular/router';
import { RouteHelperService, startWithTap } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class MainLayoutService {
  private readonly router = inject(Router);
  private readonly routeHelper = inject(RouteHelperService);

  // Loading indicator for the layout.
  private _loading = signal(false);
  // We set this to failed if the loader failed somehow. this will show the user the ability to retry
  private _failed = signal(false);
  // Loading indicator for the layout which doesn't disrupt the user.
  private _softLoading = signal(false);

  loading = this._loading.asReadonly();
  failed = this._failed.asReadonly();
  softLoading = this._softLoading.asReadonly();

  windowResized$ = new Subject();
  cancelLoader$ = new Subject();

  parentRoutes = computed(() => {
    this.routeHelper.routes();
    this.routeHelper.getRouteItemAtLevel(0)
  })

  childrenRoutes = computed(() => {
    this.routeHelper.routes();
    this.routeHelper.getRouteItemAtLevel(1)
  })

  grandChildrenRoutes = computed(() => {
    this.routeHelper.routes();
    this.routeHelper.getRouteItemAtLevel(2)
  })

  constructor() {
    fromEvent(window, 'resize')
      .pipe(takeUntilDestroyed(), debounceTime(20))
      .subscribe(() => {
        this.windowResized$.next(null);
      });

    this.router.events.pipe(takeUntilDestroyed()).subscribe((e) => {
      if (e instanceof ResolveStart) {
        this.setFailed(false);
        this.setLoading(false);
        this.cancelLoader$.next(null);
      }
    });
  }

  getRouteItems(url?: string) {
    if (!url) return undefined;
    console.log(this.routeHelper.getRouteItemAtLevel(0, url))
    return this.routeHelper.getRouteItemAtLevel(0, url);
  }

  setLoading(state: boolean) {
    this._loading.set(state);
  }

  setFailed(state: boolean) {
    this._failed.set(state);
  }

  setSoftLoading(state: boolean) {
    this._softLoading.set(state);
  }

  loaderPipe = <T>(): MonoTypeOperatorFunction<T> =>
    pipe(
      takeUntil(this.cancelLoader$),
      startWithTap(() => {
        this.setFailed(false);
        this.setLoading(true);
      }),
      tap({
        next: () => {
          this.setLoading(false);
        },
        error: () => {
          this.setFailed(true);
        },
      }),
    );

  softLoaderPipe = <T>(): MonoTypeOperatorFunction<T> =>
    pipe(
      takeUntil(this.cancelLoader$),
      startWithTap(() => {
        this.setSoftLoading(true);
      }),
      tap({
        next: () => {
          this.setSoftLoading(false);
        },
        error: () => {
          this.setSoftLoading(false);
          // ... ?
        },
      }),
    );
}
